<template>
    <div>
        <!-- <b-form-group
            :description="description"
            :label="this.$t('icon')"
            label-for="icon"
            :label-cols="2"
            :horizontal="true">
            <i :class="`nav-icon ` + icon"
            @click="iconModal.show = true"></i>
        </b-form-group> -->

        <Entrypoints v-model="listEntrypoint" label="List entrypoint" :onlyComponent="component.general.getRef()"/>
        
        <Entrypoints v-model="createEntrypoint" label="Create entrypoint" :onlyComponent="component.general.getRef()"/>

        <Entrypoints v-model="editEntrypoint" label="Update entrypoint" :onlyComponent="component.general.getRef()"/>

        <b-button variant="primary" @click="$router.push(`/component/editor/${component.general.uuid}?v=${component.settings.version}`)">{{ $t('editor') }}</b-button>
    </div>
</template>

<style scoped>
.custom-control-label:after, .custom-control-label:before {
   display: none !important;
}
</style>

<script>
import Entrypoints from './Entrypoints'

export default {
    props: {
        value: {
            type: Object
        },
        description: {
            type: String
        },
        component: {
            type: Object
        }
    },

    components: {
        Entrypoints
    },

    data: function() {
        return {
            modules: []
        }
    },

    computed: {
        content: {
            get() {
                return this.value
            },

            set(v) {
                this.$emit('input', v)
            }
        },

        listEntrypoint: {
            get() {
                return {
                    template: this.content.list_entrypoint,
                    component: this.component.general.getRef(),
                }
            },

            set({template}) {
                this.content.list_entrypoint = template
            }
        },

        createEntrypoint: {
            get() {
                return {
                    template: this.content.create_entrypoint,
                    component: this.component.general.getRef(),
                }
            },

            set({template}) {
                this.content.create_entrypoint = template
            }
        },

        editEntrypoint: {
            get() {
                return {
                    template: this.content.edit_entrypoint,
                    component: this.component.general.getRef(),
                }
            },

            set({template}) {
                this.content.edit_entrypoint = template
            }
        }
    }
}
</script>
